export const AUTH_RED = '#e10404';
export const AUTH_INK = '#1f292e';

export const authShellSx = {
  minHeight: '100vh',
  display: 'flex',
  fontFamily: "'Inter', system-ui, sans-serif",
  color: AUTH_INK,
  minWidth: { lg: 1280 },
};

export const authFormPanelSx = {
  flex: 1,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  bgcolor: '#f7f8fa',
  px: { xs: 3, sm: 4 },
  py: { xs: 4, sm: 6 },
  overflowY: 'auto',
};

export const authFieldSx = {
  '& .MuiOutlinedInput-root': {
    borderRadius: '9px',
    backgroundColor: '#fff',
    '& fieldset': { borderColor: 'rgba(0,0,0,.15)' },
    '&:hover fieldset': { borderColor: 'rgba(0,0,0,.28)' },
    '&.Mui-focused fieldset': { borderColor: AUTH_RED, borderWidth: 1 },
  },
  '& .MuiOutlinedInput-input': {
    padding: '12px 14px',
    fontSize: '14px',
    fontFamily: "'Inter', system-ui, sans-serif",
  },
  '& .MuiSelect-select': {
    padding: '12px 14px',
    fontSize: '14px',
    fontFamily: "'Inter', system-ui, sans-serif",
  },
  '& .MuiFormHelperText-root': { ml: 0 },
};

export const authPrimaryButtonSx = {
  bgcolor: AUTH_RED,
  color: '#fff',
  fontWeight: 700,
  fontSize: 14,
  py: '13px',
  borderRadius: '9px',
  textTransform: 'none',
  fontFamily: "'Inter', system-ui, sans-serif",
  boxShadow: 'none',
  '&:hover': { bgcolor: '#b00303', boxShadow: 'none' },
  '&.Mui-disabled': { bgcolor: 'rgba(225,4,4,.45)', color: '#fff' },
};

export const authLabelSx = {
  display: 'block',
  fontSize: 11,
  fontWeight: 700,
  letterSpacing: '.04em',
  textTransform: 'uppercase',
  color: AUTH_INK,
  mb: 0.75,
};

export const authMobileLogoChipSx = {
  bgcolor: '#fff',
  borderRadius: '10px',
  px: '16px',
  py: '10px',
  boxShadow: '0 1px 3px rgba(0,0,0,.06)',
};
